import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { TVendorServicePricingVariantDetails } from './types';

interface MarketplaceServiceRequestProps {
  caFirmId?: string;
}

export function useMarketplaceVendorServicePricingVariant({
  caFirmId,
}: MarketplaceServiceRequestProps = {}): {
  data?: TVendorServicePricingVariantDetails[];
  error?: unknown;
  mutate: KeyedMutator<TVendorServicePricingVariantDetails[]>;
} {
  const queryParams = new URLSearchParams();
  if (caFirmId) queryParams.set('caFirmId', caFirmId);

  const queryString = queryParams.toString();

  const { data, error, mutate } = useSWR<TVendorServicePricingVariantDetails[]>(
    `marketplace/vendors/services/variants${queryString ? `?${queryString}` : ''}`,
    SWRFetcher({
      method: 'GET',
    })
  );

  return { data, error, mutate };
}
